import { render } from "./MLearningSummaryCard.vue?vue&type=template&id=0922e4c8"
import script from "./MLearningSummaryCard.vue?vue&type=script&lang=ts"
export * from "./MLearningSummaryCard.vue?vue&type=script&lang=ts"
script.render = render

export default script